import { defineComponent as _defineComponent } from 'vue'
import {
  Heading,
  Grid,
  Row,
  InitialAvatarIcon,
  BaseIcon,
  SkeletonLoader
} from '@warrenbrasil/nebraska-web';
import { ref, computed, onBeforeUnmount, onMounted } from 'vue';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import { IProductService } from '@/modules/products/services/products';

interface Props {
  services: IProductService[];
  loading: boolean;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'ProductsViewFooter',
  props: {
    services: null,
    loading: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  services: IProductService[];
  loading: boolean;
};



const mobileWidth = 768;

const isMobile = ref<boolean>(false);

const rows = computed(() => {
  const lineInterval = isMobile.value ? 0 : 1;
  return props.services.map((service, index) => ({
    ...service,
    hasLine: index > lineInterval
  }));
});

function openLink(link: string) {
  window.open(link);
}

function handleResize() {
  isMobile.value = window.innerWidth <= mobileWidth;
}

onBeforeUnmount(() => {
  window.removeEventListener('resize', handleResize);
});

onMounted(() => {
  window.addEventListener('resize', handleResize);
  handleResize();
});

return { __sfc: true,props, mobileWidth, isMobile, rows, openLink, handleResize, Heading, Grid, Row, InitialAvatarIcon, BaseIcon, SkeletonLoader, NebraskaColors }
}

})